/** 全局/模块级设备操作锁（各方案商 connect 与热插拔并发用） */
export const deviceOperationLock = {
  xingshan: {
    number: 0,
    connectNumber: () => {
      return deviceOperationLock.xingshan.number++;
    },
    isProcessing: false,
    lock: () => {
      if (deviceOperationLock.xingshan.isProcessing) {
        return;
      }
      deviceOperationLock.xingshan.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.xingshan.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.xingshan.isProcessing,
  },
  huafenda: {
    number: 0,
    connectNumber: () => {
      return deviceOperationLock.huafenda.number++;
    },
    isProcessing: false,
    lock: () => {
      if (deviceOperationLock.huafenda.isProcessing) {
        return;
      }
      deviceOperationLock.huafenda.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.huafenda.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.huafenda.isProcessing,
  },
  beiying: {
    number: 0,
    connectNumber: () => {
      return deviceOperationLock.beiying.number++;
    },
    isProcessing: false,
    lock: () => {
      if (deviceOperationLock.beiying.isProcessing) {
        return;
      }
      deviceOperationLock.beiying.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.beiying.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.beiying.isProcessing,
  },
  jiangmeng: {
    number: 0,
    connectNumber: () => {
      return deviceOperationLock.jiangmeng.number++;
    },
    isProcessing: false,
    lock: () => {
      if (deviceOperationLock.jiangmeng.isProcessing) {
        return;
      }
      deviceOperationLock.jiangmeng.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.jiangmeng.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.jiangmeng.isProcessing,
  },
  freq: {
    number: 0,
    connectNumber: () => {
      return deviceOperationLock.freq.number++;
    },
    isProcessing: false,
    lock: () => {
      if (deviceOperationLock.freq.isProcessing) {
        return;
      }
      deviceOperationLock.freq.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.freq.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.freq.isProcessing,
  },
  zhanli: {
    number: 0,
    connectNumber: () => {
      return deviceOperationLock.zhanli.number++;
    },
    isProcessing: false,
    lock: () => {
      if (deviceOperationLock.zhanli.isProcessing) {
        return;
      }
      deviceOperationLock.zhanli.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.zhanli.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.zhanli.isProcessing,
  },
  rongyuan: {
    number: 0,
    connectNumber: () => {
      return deviceOperationLock.rongyuan.number++;
    },
    isProcessing: false,
    lock: () => {
      if (deviceOperationLock.rongyuan.isProcessing) {
        return;
      }
      deviceOperationLock.rongyuan.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.rongyuan.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.rongyuan.isProcessing,
  },
  beiyingMouse: {
    number: 0,
    isProcessing: false,
    connectNumber: () => {
      return deviceOperationLock.beiyingMouse.number++;
    },
    lock: () => {
      if (deviceOperationLock.beiyingMouse.isProcessing) {
        return;
      }
      deviceOperationLock.beiyingMouse.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.beiyingMouse.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.beiyingMouse.isProcessing,
  },
  yxt: {
    number: 0,
    connectNumber: () => {
      return deviceOperationLock.yxt.number++;
    },
    isProcessing: false,
    lock: () => {
      if (deviceOperationLock.yxt.isProcessing) {
        return;
      }
      deviceOperationLock.yxt.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.yxt.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.yxt.isProcessing,
  },
  zhwx: {
    number: 0,
    connectNumber: () => {
      return deviceOperationLock.zhwx.number++;
    },
    isProcessing: false,
    lock: () => {
      if (deviceOperationLock.zhwx.isProcessing) {
        return;
      }
      deviceOperationLock.zhwx.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.zhwx.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.zhwx.isProcessing,
  },
  sdcx: {
    number: 0,
    connectNumber: () => {
      return deviceOperationLock.sdcx.number++;
    },
    isProcessing: false,
    lock: () => {
      if (deviceOperationLock.sdcx.isProcessing) {
        return;
      }
      deviceOperationLock.sdcx.isProcessing = true;
    },
    unlock: () => {
      deviceOperationLock.sdcx.isProcessing = false;
    },
    isLocked: () => deviceOperationLock.sdcx.isProcessing,
  },
};
